var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item',_vm._l((_vm.tabs),function(tab,index){return _c('q-radio',{key:index,attrs:{"val":tab.selector,"label":tab.name.toUpperCase()},on:{"input":_vm.select_tab},model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }